import { render, staticRenderFns } from "./loctypelist.vue?vue&type=template&id=661a1b3c&scoped=true"
import script from "./loctypelist.vue?vue&type=script&lang=js"
export * from "./loctypelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a1b3c",
  null
  
)

export default component.exports